<script setup lang="ts">
import { IonModal } from '@ionic/vue';
import { useI18n } from 'vue-i18n';

defineProps<{
  visible: boolean;
  version: string;
}>();

const emit = defineEmits<{
  (e: 'update'): void;
  (e: 'dismiss'): void;
}>();

const { t } = useI18n();
</script>

<template>
  <IonModal
    id="app-update-modal"
    :is-open="visible"
    :backdrop-dismiss="true"
    @did-dismiss="emit('dismiss')"
  >
    <div class="wrapper">
      <div class="glow" />
      <h2 class="title">
        {{ t('app_update.title') }}
      </h2>
      <p class="description">
        {{ t('app_update.description', { version }) }}
      </p>
      <div class="buttons">
        <button
          class="later-button"
          @click="emit('dismiss')"
        >
          {{ t('app_update.not_now') }}
        </button>
        <button
          class="update-button"
          @click="emit('update')"
        >
          {{ t('app_update.update_now') }}
        </button>
      </div>
    </div>
  </IonModal>
</template>

<style>
ion-modal#app-update-modal {
  --width: fit-content;
  --min-width: 327px;
  --max-width: 340px;
  --height: fit-content;
  --border-radius: 21px;
  --background: #121212;
  --box-shadow: 0 28px 48px rgba(0, 0, 0, 0.4);
}
</style>

<style scoped>
.wrapper {
  position: relative;
  padding: 32px 24px 28px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  overflow: hidden;
}

.glow {
  position: absolute;
  top: -73px;
  left: 50%;
  transform: translateX(-50%);
  width: 158px;
  height: 145px;
  border-radius: 50%;
  background: #853AFF;
  pointer-events: none;
  filter: blur(110px);
}

.title {
  font-family: var(--fontFamily);
  font-size: 21px;
  font-weight: 600;
  color: #fff;
  margin: 0 0 16px 0;
  z-index: 1;
}

.description {
  font-family: var(--fontFamily);
  font-size: 16px;
  font-weight: 400;
  color: #fff;
  line-height: 1.18;
  margin: 0 0 28px 0;
  max-width: 286px;
  z-index: 1;
}

.buttons {
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: 11px;
  z-index: 1;
}

.later-button,
.update-button {
  flex: 1;
  height: 54px;
  border-radius: 7px;
  border: none;
  outline: none;
  cursor: pointer;
  font-family: var(--fontFamily);
  font-size: 12.5px;
  font-weight: 600;
  letter-spacing: 0.94px;
  text-transform: uppercase;
  white-space: nowrap;
  transition: opacity 0.2s ease-in-out;
}

.later-button {
  background: rgba(166, 154, 185, 0.1);
  color: rgba(255, 255, 255, 0.6);
}

.later-button:hover {
  opacity: 0.8;
}

.update-button {
  background: linear-gradient(
    90deg,
    #8301ea 0%,
    #ec126c 52.6%,
    #ffb13b 100%
  );
  color: #fff;
}

.update-button:hover {
  opacity: 0.9;
}
</style>
